import { 
    useState, 
    useEffect, 
} from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { withPather } from 'react-pather';
import { DomainsTable } from './common';
import { ConversionMarker } from './common/DomainsTable';
import Loader from '../../../Loader';

const rowsPerPage = 30;

const Domains = ({ pather }) => {

    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [excludedMarkers, setExcludedMarkers] = useState([ConversionMarker.DELETED]);

    // Pagination
    const [offset, setOffset] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const fetchTrends = () => {
        setLoading(true);
        axios.get(pather.back.Settings.domains, 
            { 
                params: { 
                    perPage: rowsPerPage,
                    offset,
                    excludedMarkers: JSON.stringify(excludedMarkers),
                } 
            }
        )
        .then(response => {
            const data = response.data;
            setRows(data?.rows);
            setTotalPages(data?.total_pages);
        })
        .catch(error => {
            console.log(error);
            const status = error?.response?.data?.status;
            status && enqueueSnackbar(status, { variant: 'error' });
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        fetchTrends();
    }, [offset]);

    const handleOffsetChange = (event, value) => setOffset(value - 1);

    return (
        <>
            {
                loading ? 
                <Loader/> :
                <DomainsTable 
                    rows={rows} 
                    totalPages={totalPages} 
                    offset={offset} 
                    handleOffsetChange={handleOffsetChange}
                    excludedMarkers={excludedMarkers}
                />
            }
        </>
    )
}

export default withPather()(Domains);